export const searchWords = (q) => (q || "").toLowerCase().split(/[\s\-_/]+/).filter(Boolean);

// Cerca per nome, colore, stagione o codice (es. "8001 a26 nero" o "8001-a26-nero")
export const productMatches = (p, words) => {
  if (!words.length) return true;
  const hay = `${p.name || ""} ${p.color || ""} ${p.season || ""} ${(p.sku || "").replace(/[-_/]/g, " ")}`.toLowerCase();
  return words.every((w) => hay.includes(w));
};
